import type { IUser } from '~/entities/user/user/interfaces/user'

import type { Acl } from '~/features-shared/libs/interfaces/authorization'
import type { IEntity } from '~/features-shared/libs/interfaces/entity'

/**
 * Moderation status of comment/answer
 * @info UpdatedByAuthor   - Answer updated by author
 * @info UpdatedByAdmin    - Answer updated by admin
 * @info ModeratedByAuthor - Comment/reply updated by author
 * @info ModeratedByAdmin  - Comment/reply updated by author
 * @info NotModerated  - Comment/reply or answer is not moderated/edited.
 */
export enum ModerationStatus {
  UpdatedByAuthor = 'updated_by_author',
  UpdatedByAdmin = 'updated',
  ModeratedByAuthor = 'moderatedByAuthor',
  ModeratedByAdmin = 'moderatedByAdmin',
  NotModerated = 'notModerated,',
}

export interface IComment extends IEntity {
  parent_comment_uri?: string
  description: string
  author: IUser
  content_uri: string
  moderation_state: ModerationStatus
  access_state: string
  modified_at: string
  nb_replies: number
  nb_endorses: number
  current_user_endorse?: { endorseUri: string } | boolean
  forwarded_from?: string
  _acl: Acl
  published_at: string
  moderated_at: string
}

export interface IAnswer extends IComment {
  can_rate: boolean
  can_validate: boolean
  has_rated: boolean
  qna_id: string
  is_validated: boolean
  /** answer edited or moderated by author or admin */
  moderation_status: ModerationStatus
}
/** Content related event names such as edited, commented by, created, moderated,  etc. & user who done that event */
export interface IContentEvent { name?: string | Event, author?: IUser, date?: string }
